import React from 'react';
import { Box, Typography } from '@mui/material';
import { AGENTS } from '../../globalChat/constants';
import '../styles/GamePreviewBar.css';

// Stessa mappa di icone usata in GameNavigationBar
const GAME_ICONS = {
  quiz: '/people/quiz.png',
  fillthebox: '/people/fillthebox.png',
  selectgroup: '/people/selectgroup.png',
  matchpairs: '/people/matchpairs.png',
  rearrange: '/people/rearrange.png',
  crossword: '/people/crossword.png',
  scrittura: '/people/scrittura.png',
  video: '/people/video.png',
};

// Funzione di utilità per verificare se un'attività è un video YouTube
const hasYoutubeVideo = (chat) => {
  if (!chat || !chat.last_message || !chat.last_message.text) return false;
  try {
    const messageContent = JSON.parse(chat.last_message.text);
    if (messageContent.type === 'youtube' && messageContent.videoId) {
      return true;
    }
  } catch (error) {
    const textContent = chat.last_message.text;
    return textContent.includes('youtube.com') || textContent.includes('youtu.be');
  }
  return false;
};

/**
 * Componente per mostrare un'anteprima delle attività presenti nel gioco
 */
const GamePreviewBar = ({ chats }) => {
  if (!chats || chats.length === 0) {
    return null;
  }

  return (
    <Box className="game-preview-container">
      <Typography variant="h6" className="game-preview-title">
        Attività incluse:
      </Typography>
      
      <div className="game-preview-bar">
        {chats.map((chat, index) => {
          const gameType = chat.agent && chat.agent.toLowerCase();
          let iconPath = null;
          let displayText = '';

          if (gameType && GAME_ICONS[gameType]) {
            if (gameType === 'scrittura') {
              if (hasYoutubeVideo(chat)) {
                iconPath = GAME_ICONS['video'];
                const videoAgent = AGENTS.find(agent => agent.key === 'video');
                displayText = videoAgent ? videoAgent.label : 'Video';
              } else {
                iconPath = GAME_ICONS['scrittura'];
                const scritturaAgent = AGENTS.find(agent => agent.key === 'scrittura');
                displayText = scritturaAgent ? scritturaAgent.label : 'Lettura';
              }
            } else {
              iconPath = GAME_ICONS[gameType];
              const agent = AGENTS.find(agent => agent.key === gameType);
              displayText = agent ? agent.label : gameType;
            }
          }

          return (
            <div key={chat.id} className="game-preview-item" title={displayText}>
              {iconPath ? (
                <div className="game-preview-icon-wrapper">
                  <img src={iconPath} alt={displayText} className="game-preview-icon" />
                </div>
              ) : (
                <span className="game-preview-number">{index + 1}</span>
              )}
            </div>
          );
        })}
      </div>
    </Box>
  );
};

export default GamePreviewBar; 